import Vue from 'vue';
import router from './router';
import ElementUI from 'element-ui';
import { ajax } from "jquery";
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import '@wangeditor/editor/dist/css/style.css';

Vue.use(ElementUI);

const domin = "http://www.ocmzhyl.com";

Vue.prototype.glb = {
    domin: "http://www.ocmzhyl.com"
}


Vue.config.productionTip = false
Vue.prototype.domin = domin;
Vue.prototype.vajax = ajax

let errfuc = function (res) {
    let tips = "";

    switch (res.result) {
        case "dateexist":
            tips = "日期已存在";
            break;
        case "noexist":
            tips = "用户不存在";
            break;
        case "pwderror":
            tips = "密码有误";
            break;
        case "fail":
            tips = "该请求操作失败";
            break;
        case "relate":
            tips = "已关联业务员";
            break;
        case "moneyless":
            tips = "提现余额不足";
            break;
        case "errorstatus":
            tips = "提现状态有误";
            break;
        case "branchbind":
            tips = "有分校关联业务员";
            break;
        case "lessbalance":
            tips = "提现余额不足";
            break;
        case "schoolbind":
            tips = "有学校关联业务员";
            break;
        case "streetbind":
            tips = "有街道关联业务员";
            break;
        case "communitybind":
            tips = "有社区关联业务员";
            break;
        case "exsit":
            tips = "已存在";
            break;
        case "phoneexist":
            tips = "不是你的区域";
            break;
        case "nopolicy":
            tips = "没有相应的产品";
            break;
        case "notyourarea":
            tips = "不是你的区域";
            break;
        case "nopassword":
            tips = "密码应为8位数以上，需有数字、字母、特殊字符结合";
            break;
        case "moreerror":
            tips = "密码错误过多，请稍后再试";
            break;
        case "overtime":
            tips = "超过48小时，无法回复";
            break;
        case "errormessage":
            tips = String(res.message);
            break;
        case "nologin":
            alert("登录时效过期...")
            // console.log("nologin")
            location.href = domin + "/healman/#/"
            break;
        default:
            tips = "网络请求异常/拥堵,请稍后再试...";
            console.log(res)
            break;
    }

    if (res.result != "nologin") {
        alert(tips);
    }

    return false;
};


Vue.prototype.iget = function (url, data, succ,) {
    ajax({
        url: url,
        method: "GET",
        headers: {
            "content-type": "application/x-www-form-urlencoded",
        },
        data: data,
    })
        .then((res) => {
            if (res.result !== "success") {
                errfuc(res);
            }

            succ(res);
        })
        .catch((err) => {
            console.log(err);
        });
};
// post请求方法 ,无前置loading效果
Vue.prototype.ipst = function (url, data, succ) {
    ajax({
        url: url,
        method: "POST",
        headers: {
            "content-type": "application/x-www-form-urlencoded",
        },
        data: data,
    })
        .then((res) => {
            if (res.result !== "success") {
                errfuc(res);
            }
            succ(res);
        })
        .catch((err) => {
            console.log(err);
        });
};
Vue.prototype.ipost = function (url, data, succ, err) {
    const loading = this.$loading({
        target: document.querySelector('#app'),
        lock: true,
        text: '加载中...'
    })
    ajax({
        url: url,
        method: "POST",
        headers: {
            "content-type": "application/x-www-form-urlencoded",
        },
        data: data,
    })
        .then((res) => {
            loading.close()
            if (res.result !== "success") {
                if (!!err) err()
                errfuc(res);
                return
            }
            succ(res);
        })
        .catch((err) => {
            loading.close()
            this.$message("fail:", JSON.stringify(err.responseText))
            console.log("请求出错:", err);
        });
};


new Vue({
    router,
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this
    }
}).$mount('#app')